<style scoped>
.list-unstyled {
  list-style-type: none;
}
</style>

<template>
  <anchor-base ref="base" :user="user" :logout-method="logout">
    <template v-slot:menu="props">
      <sidebar
        :expanded="props.expanded"
        :hovering="hoveringSidebar"
      />
    </template>

    <template v-slot:subheader>
      <login-as v-if="enableLoginAs"/>
    </template>

    <slot></slot>
  </anchor-base>
</template>

<script>
import { CLEAR_USER, DEFINE_HAS_LOGGED_OUT } from '@/store/modules/user/actions';

import Sidebar from '@/components/utils/Sidebar';
import LoginAs from '@/components/base/LoginAs';


export default {
  name: 'AuthenticatedBase',
  components: {
    LoginAs,
    Sidebar,
  },
  data: () => ({
    mounted: false,
  }),
  computed: {
    enableLoginAs() {
      return process.env.NODE_ENV !== 'production';
    },
    hoveringSidebar() {
      if (!this.mounted) {
        return false;
      }
      return this.$refs.base.$children[0].$children[0].isMouseover;
    },
    user() {
      return this.$store.getters.user;
    },
    menuLinks() {
      const arr = [{
        icon: 'mdi-cog',
        title: 'Account Settings',
        to: { name: 'AdminAccountSettingsView' },
      }];

      if (this.user.permissions.includes('anchorapps:admin')) {
        arr.push({
          icon: 'mdi-shield-star',
          title: 'Administration Controls',
          to: { name: 'AdminBaseControlView', params: { slug: 'users' } },
        });
      }

      return arr;
    },
  },
  methods: {
    logout() {
      this.$requests.get('logout').then(() => {
        this.dialog = false;
        this.menu = false;
        this.$store.dispatch(CLEAR_USER);
        this.$store.dispatch(DEFINE_HAS_LOGGED_OUT, { hasLoggedOut: true });
        this.$router.push({ name: 'LoginView' });
      }).catch(() => {
        this.$toast.error('Unable to perform the logout. Try again.', { timeout: 3000 });
      });
    },
  },
  mounted() {
    this.mounted = true;
  },
};
</script>
